import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";
import { faqItems } from "@/mocks/comics";

export default function Faq() {
  usePageMeta({
    title: "常见问题 - 羞羞漫画韩国",
    description:
      "羞羞漫画韩国常见问题解答，包含网站介绍、题材分类、榜单说明、评分机制与漫画推荐方式等读者关心的问题。",
  });

  return (
    <main className="w-full bg-background-50">
      <section className="border-b border-background-200 bg-background-100 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <nav className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500" aria-label="面包屑">
            <Link to="/" className="transition-colors hover:text-primary-600">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <span className="text-foreground-800">常见问题</span>
          </nav>
          <h1 className="mt-4 font-display text-3xl font-black text-foreground-950 md:text-4xl">常见问题</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            关于羞羞漫画韩国的常见疑问，我们都整理在这里了。
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 py-12 md:px-6">
        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <details
              key={item.q}
              open={i === 0}
              className="group rounded-xl bg-background-100 p-5 transition-colors hover:bg-background-200/50 md:p-6"
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-base font-semibold text-foreground-950">
                <span className="flex items-center gap-3">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xs font-bold text-primary-700">
                    Q{i + 1}
                  </span>
                  {item.q}
                </span>
                <i
                  className="ri-add-line text-xl text-primary-500 transition-transform duration-300 group-open:rotate-45"
                  aria-hidden="true"
                ></i>
              </summary>
              <p className="mt-4 pl-10 text-sm leading-7 text-foreground-700">{item.a}</p>
            </details>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center gap-3 rounded-2xl bg-accent-100/70 px-6 py-10 text-center">
          <i className="ri-question-answer-line text-3xl text-accent-600" aria-hidden="true"></i>
          <h2 className="font-display text-xl font-black text-foreground-950">还有别的问题？</h2>
          <p className="max-w-md text-sm leading-relaxed text-foreground-700">
            没找到想要的答案？欢迎通过联系我们页面留言，我们会尽快为你解答。
          </p>
          <Link
            to="/contact"
            className="mt-2 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            联系我们 <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
      </section>

      {/* FAQPage schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqItems.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
    </main>
  );
}